import { render, staticRenderFns } from "./LeaderboardSetListComponent.vue?vue&type=template&id=66b5f3e1&scoped=true&"
import script from "./LeaderboardSetListComponent.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardSetListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardSetListComponent.vue?vue&type=style&index=0&id=66b5f3e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b5f3e1",
  null
  
)

export default component.exports